import type { ContestCategoryId } from '../../types/contestCatalog';
import { brandColors, brandGradients } from '@config/brandTokens';

export interface CategoryRowStyle {
  label: string;
  accent: string;
  headerBg: string;
  headerText: string;
  rowBg: string;
  rowHover: string;
  rowText: string;
  rowTarget: string;
}

export const CATEGORY_ROW_STYLES: Record<ContestCategoryId, CategoryRowStyle> = {
  skill: {
    label: 'Skill',
    accent: brandColors.blue,
    headerBg: brandGradients.contestHeader,
    headerText: brandColors.white,
    rowBg: '#eef2ff',
    rowHover: '#e0e7ff',
    rowText: brandColors.navy,
    rowTarget: brandColors.blue,
  },
  drill: {
    label: 'Drill',
    accent: brandColors.violet,
    headerBg: `linear-gradient(135deg, #3d0f6b 0%, ${brandColors.violet} 55%, #8b3fd9 100%)`,
    headerText: brandColors.white,
    rowBg: '#f3e8ff',
    rowHover: '#ede9fe',
    rowText: '#4c1d95',
    rowTarget: brandColors.violet,
  },
  fitness: {
    label: 'Fitness',
    accent: brandColors.green,
    headerBg: `linear-gradient(135deg, #1a5c10 0%, ${brandColors.green} 55%, #6fd04a 100%)`,
    headerText: '#ffffff',
    rowBg: '#d1fae5',
    rowHover: '#a7f3d0',
    rowText: '#065f46',
    rowTarget: '#059669',
  },
  tactical: {
    label: 'Tactical',
    accent: '#f59e0b',
    headerBg: 'linear-gradient(135deg, #78350f 0%, #d97706 55%, #fbbf24 100%)',
    headerText: '#ffffff',
    rowBg: '#fef3c7',
    rowHover: '#fde68a',
    rowText: '#92400e',
    rowTarget: '#d97706',
  },
  match_intelligence: {
    label: 'Match Intelligence',
    accent: '#ec4899',
    headerBg: 'linear-gradient(135deg, #831843 0%, #db2777 55%, #f472b6 100%)',
    headerText: '#ffffff',
    rowBg: '#fce7f3',
    rowHover: '#fbcfe8',
    rowText: '#9d174d',
    rowTarget: '#db2777',
  },
};

export function getCategoryRowStyle(categoryId: ContestCategoryId): CategoryRowStyle {
  return CATEGORY_ROW_STYLES[categoryId] ?? CATEGORY_ROW_STYLES.skill;
}
